var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.63,
    height: 30.63,
    viewBox: "0 0 30.63 30.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47488",
    "data-name": "Group 47488",
    transform: "translate(30.63 30.63) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54500",
    "data-name": "Path 54500",
    d: "M15.315,0A15.315,15.315,0,1,1,0,15.315,15.315,15.315,0,0,1,15.315,0Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "angle-right",
    d: "M.333,11.2,0,10.871l5.1-5.1a.237.237,0,0,0,0-.334L0,.333.333,0l5.1,5.1a.708.708,0,0,1,0,1l-5.1,5.1Z",
    transform: "translate(18.273 21.097) rotate(180)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowCircled);
export default __webpack_public_path__ + "static/media/right-arrow-circled.7e6661c334a31c3584b8a4ba5b0d7734.svg";
export { ForwardRef as ReactComponent };